import type {
  SurveyDetails,
  SurveyDetailsParams,
  SchoolType,
  SurveyGrouping,
} from 'app/common/types/surveys'

import type { Request } from '../../../index'
import { convertSurvey, SurveyDto } from '../common'

type SurveyDetailsParamsDto = {
  group_by: SurveyGrouping
  city_id?: Array<number>
  district_id?: Array<number>
  school_type?: Exclude<SchoolType, ''> | Array<Exclude<SchoolType, ''>>
  school_id?: Array<number>
}

type SurveyDetailsResultDto = {
  survey: SurveyDto
  aggregation?: {
    group_by?: 'day' | 'week' | 'month'
    total?: number
    positive?: number
    negative?: number
    chart_data: Array<{
      label: string
      total: number
      positive: number
      negative: number
    }>
  } | null
}

type SurveyUrlParams = {
  id: string
}

const convertIds = (ids: Array<string>) =>
  ids.length ? ids.map((v) => parseInt(v, 10)) : undefined

export const convertParams = (
  params: SurveyDetailsParams,
): [SurveyDetailsParamsDto, SurveyUrlParams] => [
  {
    group_by: params.grouping,
    city_id: convertIds(params.cityIds),
    district_id: convertIds(params.districtIds),
    school_type: params.schoolTypes.length === 1 ? params.schoolTypes[0] : params.schoolTypes.length ? params.schoolTypes : undefined,
    school_id: convertIds(params.schoolIds),
  },
  { id: params.surveyId },
]

export const convertResult = (data: SurveyDetailsResultDto): SurveyDetails => ({
  survey: convertSurvey(data.survey),
  aggregation: {
    total: data.aggregation?.total || 0,
    positive: data.aggregation?.positive || 0,
    negative: data.aggregation?.negative || 0,
    grouping: data.aggregation?.group_by || 'day',
    chartData: (data.aggregation?.chart_data || []).map((item) => ({
      label: item.label,
      total: item.total || 0,
      positive: item.positive || 0,
      negative: item.negative || 0,
    })),
  },
})

export const GET_SURVEY: Request<SurveyDetailsParams, SurveyDetails, SurveyUrlParams> = [
  'food/surveys/{id}',
  'get',
  ['data'],
]
